<template>
  <div class="license-status-label-component
    flex-col flex justify-center items-start
    w-[228px] h-[107px]
    border border-solid border-[#62626233]
    pl-[20px] rounded-xs">

    <div class="license-status-label-available pl-[4px] mb-[7px] flex w-full">
      <div class="w-[22px] h-[22px]">
        <img src="@/static/icons/check_solid_black.svg"
          class="table-license-icon-locked h-full w-[14px] block">
      </div>
      <span class="license-status-text-available text-black text-xs ml-[6px] mt-[3px] text-left">{{$t('activation.licenseAvailable')}}</span>
    </div>

    <div class="license-status-label-locked flex w-full">
      <div class="w-[22px] h-[22px]">
        <img src="@/static/icons/lock_solid_black.svg"
          class="table-license-icon-locked h-full w-full">
      </div>
      <span class="license-status-text-locked text-black text-xs ml-[10px] mt-[3px] text-left">{{$t('activation.licenseLockedToAPlayer')}}</span>
    </div>
  </div>
</template>

<script src="./license-status-label.js"></script>
